var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavvioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,0h-43L0,10.6v41.6L10.5,64h43L64,53.4V11.8L53.5,0z M22.4,11.5c1.9-0.3,3.9-0.2,5.9-0.3 c7.3,0,14.7,0,22.1,0c-3.7,4-23.8,25.3-26.8,28.4c-3.9-4.8-8.7-8.8-9.8-15.3C12.6,17.6,15.7,12.7,22.4,11.5L22.4,11.5z M43.6,52.5 c-1.9,0.3-3.9,0.2-5.9,0.3c-7.3,0-14.7,0-22.1,0c3.7-4,23.8-25.3,26.8-28.4c3.9,4.8,8.7,8.8,9.8,15.3C53.4,46.4,50.3,51.3,43.6,52.5 L43.6,52.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavvioIcon);
export default __webpack_public_path__ + "static/media/savvio-icon.661197ef0d7379581c87d92559c3f15d.svg";
export { ForwardRef as ReactComponent };